import { render } from "./ProductBox.vue?vue&type=template&id=6cded104&scoped=true"
import script from "./ProductBox.vue?vue&type=script&lang=js"
export * from "./ProductBox.vue?vue&type=script&lang=js"

import "./ProductBox.vue?vue&type=style&index=0&id=6cded104&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cded104"]])

export default __exports__